import React, { useState, useEffect } from 'react';
import './AddPurchase.css';
import axios from "axios";
import { useParams } from "react-router-dom";

const AddAidedStaffSalary = () => {
  const { user_id } = useParams();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const [formData, setFormData] = useState({
    user_id: user_id,
    basic: "0.00",
    sp: "0.00",
    wa: "0.00",
    da_per: "",
    da_amt: "0.00",
    hra: "0.00",
    ma: "0.00",
    total_days: "0",
    lop: "0",
    working_days: "0",
    gross: "0.00",
    tpf: "0.00",
    tpfd: "0.00",
    cps_r: "0.00",
    cps_a1: "0.00",
    gis: "0.00",
    nhis: "0.00",
    fa_coop: "0.00",
    pt: "0.00",
    it_sr: "0.00",
    deduction: "0.00",
    net_salary: "0.00",

    name: "",
    designation: "",
    department: "",
    doj: "",
  });

  const getDaysInCurrentMonth = () => {
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate();
  };

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => {
      let updated = { ...prev, [name]: value };

      // DA % → DA Amount
      if (name === "da_per") {
        const percent = Number(value) || 0;
        const basic = Number(prev.basic) || 0;
        updated.da_amt = ((basic * percent) / 100).toFixed(2);
      }

      return updated;
    });
  };


  const validate = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Staff name is required";
    if (!formData.basic) newErrors.basic = "Basic salary is required";
    // Add more validations as needed
    return newErrors;
  };

  useEffect(() => {
    axios.post(`${API_BASE_URL}user_detail.php`, { user_id: user_id })
      .then((response) => {
        if (response.data.head.code === 200) {
          // setFormData(response.data.body);
          setFormData(prev => ({
            ...prev,            // keep all your default fields
            ...response.data.body // overwrite only fields that API provides
          }));
          // setFilteredOrders(response.data.body);

        } else {
          console.error("Error Fetching Data:", response.data.head.msg);
          setFormData([]);
          // setFilteredOrders([]);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        setFormData([]);
        // setFilteredOrders([]);
      }).finally(() => {
        // setLoading(false); // Set loading to false after API call
      });
  }, []);

  // Auto-fill total days in current month, and derive working days from LOP
  useEffect(() => {
    const days = getDaysInCurrentMonth();

    setFormData(prev => ({
      ...prev,
      total_days: days
    }));

    const total = Number(formData.total_days) || 0;
    const lop = Number(formData.lop) || 0;

    const working = total - lop;
    setFormData(prev => ({
      ...prev,
      working_days: working >= 0 ? working : 0
    }));

  }, [formData.total_days, formData.lop]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      setErrors({});
      console.log("Submitted:", formData);
      // Submit to backend here

      axios.post(`${API_BASE_URL}salary_aided_add.php`, formData)
        .then((response) => {
          if (response.data.head.code === 200) {
            // setDepartmentList(response.data.body);
            // setFilteredOrders(response.data.body);
            window.history.back();

          } else {
            console.error("Error Fetching Data:", response.data.head.msg);
            // setDepartmentList([]);
            // setFilteredOrders([]);
          }
        })
        .catch((error) => {
          console.error("API Error:", error);
          // setDepartmentList([]);
          // setFilteredOrders([]);
        }).finally(() => {
          // setLoading(false); // Set loading to false after API call
        });
    }
  };

  const renderError = (field) =>
    errors[field] && <small className="text-danger">{errors[field]}</small>;

  useEffect(() => {
    // Sum of earnings before LOP deduction
    const earnings =
      (Number(formData.basic) || 0) +
      (Number(formData.sp) || 0) +
      (Number(formData.wa) || 0) +
      (Number(formData.da_amt) || 0) +
      (Number(formData.hra) || 0) +
      (Number(formData.ma) || 0);

    // Reduce earnings by LOP (per-day amount * lop days), same approach as the
    // self-financing salary form: perDay = earnings / total_days
    const totalDays = Number(formData.total_days) || 1;
    const lop = Number(formData.lop) || 0;
    const perDay = earnings / totalDays;
    const lopAmt = perDay * lop;

    const gross = earnings - lopAmt;

    const deduction =
      (Number(formData.tpf) || 0) +
      (Number(formData.tpfd) || 0) +
      (Number(formData.cps_r) || 0) +
      (Number(formData.cps_a1) || 0) +
      (Number(formData.gis) || 0) +
      (Number(formData.nhis) || 0) +
      (Number(formData.fa_coop) || 0) +
      (Number(formData.pt) || 0) +
      (Number(formData.it_sr) || 0);

    const netSalaryAmount = gross - deduction;

    setFormData((prev) => ({
      ...prev,
      gross: gross.toFixed(2),
      deduction: deduction.toFixed(2),
      net_salary: netSalaryAmount.toFixed(2),
    }));
  }, [
    formData.basic,
    formData.sp,
    formData.wa,
    formData.da_amt,
    formData.hra,
    formData.ma,
    formData.total_days,
    formData.lop,
    formData.tpf,
    formData.tpfd,
    formData.cps_r,
    formData.cps_a1,
    formData.gis,
    formData.nhis,
    formData.fa_coop,
    formData.pt,
    formData.it_sr,
  ]);


  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="mb-0">Add Aided Staff Salary</h4>
        <button className="btn-top" onClick={() => window.history.back()}>Back</button>
      </div>

      <form onSubmit={handleSubmit} noValidate>
        <div className="row g-3">
          {[
            { label: "Name", name: "name", value: formData.name, read: true },
            { label: "Designation", name: "designation", value: formData.desig_name, read: true },
            { label: "Department", name: "department", value: formData.depart_name, read: true },
            { label: "Date of Joining", name: "doj", placeholder: "dd-mm-yyyy", value: formData.date_of_join, read: true },
            { label: "Basic", name: "basic", value: formData.basic, read: true },
            { label: "Total Days", name: "total_days", value: formData.total_days, read: true },
            { label: "LoP", name: "lop", value: formData.lop, read: true },
            { label: "Working Days", name: "working_days", value: formData.working_days, read: true },
            
            { label: "SP", name: "sp" },
            { label: "WA", name: "wa" },
            { label: "DA %", name: "da_per" },
            { label: "DA", name: "da_amt", value: formData.da_amt, read: true },
            { label: "HRA", name: "hra" },
            { label: "MA", name: "ma" },
            { label: "Gross", name: "gross", value: formData.gross, read: true },
            { label: "TPF", name: "tpf" },
            { label: "TPFD", name: "tpfd" },
            { label: "CPS(R)", name: "cps_r" },
            { label: "CPS(A1)", name: "cps_a1" },
            { label: "GIS", name: "gis" },
            { label: "NHIS", name: "nhis" },
            { label: "FA/Coop", name: "fa_coop" },
            { label: "PT", name: "pt" },
            { label: "IT/SR", name: "it_sr" },
            { label: "Deduction", name: "deduction", value: formData.deduction, read: true },
            { label: "Net Salary", name: "net_salary" , value: formData.net_salary, read: true },
          ].map(({ label, name, value, read }) => (
            <div className="col-lg-3 col-md-6 col-sm-12" key={name}>
              <label className="form-label">{label}</label>
              <input
                type="text"
                className="form-control"
                name={name}
                value={value}
                onChange={handleChange}
                readOnly={read ? true : false}
              />
              {renderError(name)}
            </div>
          ))}
        </div>

        <div className="d-flex justify-content-end mt-4 gap-2">
          <button type="submit" className="btn-submit">Submit</button>
          <button type="button" className="btn-cancel" onClick={() => window.history.back()}>Cancel</button>
        </div>
      </form>
    </div>
  );
};

export default AddAidedStaffSalary;